import { MapComponent } from "@/components/MapComponent";
import { PageContainer } from "@/components/PageContainer";
import { navItemsIds } from "@/utils/nav-items";
import { Box } from "@mui/material";
import { ContactUsSection } from "./ContactUsSection";
import { HomeBanner } from "./HomeBanner";
import { MetricSection } from "./MetricSection";
import { OurSolutionsSection } from "./OurSolutionsSection/OurSolutionsSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { BecomeRepresentativeSection } from "./BecomeRepresentativeSection";
import { FAQSection } from "./FAQSection";
import { BranchesWeServe } from "./BranchesWeServe";
import { TaxRegimesWeServe } from "./TaxRegimesWeServe";
import { useEffect } from "react";
import { scroller } from "react-scroll";

export function Home() {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash) return;

    const t = setTimeout(() => {
      scroller.scrollTo(hash, {
        smooth: true,
        offset: -100,
        duration: 500,
      });
    }, 50);

    return () => clearTimeout(t);
  }, []);

  return (
    <PageContainer>
      <Box id={navItemsIds.inicio}>
        <HomeBanner />
      </Box>

      <Box id={navItemsIds.nossasSolucoes}>
        <OurSolutionsSection />
      </Box>

      <Box id={navItemsIds.regimesQueAtendemos}>
        <TaxRegimesWeServe />
      </Box>

      <Box id={navItemsIds.ramosQueAtendemos}>
        <BranchesWeServe />
      </Box>

      <Box id={navItemsIds.nossoContato}>
        <ContactUsSection />
      </Box>

      <Box id={navItemsIds.nossosNumeros}>
        <MetricSection />
      </Box>

      <Box id={navItemsIds.depoimentos}>
        <TestimonialsSection />
      </Box>

      <Box id={navItemsIds.sejaRepresentante}>
        <BecomeRepresentativeSection />
      </Box>

      <FAQSection />

      <Box id={navItemsIds.ondeEstamos}>
        <MapComponent
          position={[-19.374928205831427, -40.07246607548706]}
          zoom={15}
          popupText="Aqui está nossa empresa! 📍"
        />
      </Box>
    </PageContainer>
  );
}
